
import { Vue, Component } from 'vue-property-decorator'
import { Global } from '@/store'
import { appName } from '@/env'

@Component
export default class Login extends Vue {
  username: string = ''
  password: string = ''
  get title(){ return appName || 'Cara' }
  async submit(){
    await Global.authenticate({ username: this.username, password: this.password })
    this.$router.push({ name: 'BiometricAttempts' })
  }
}
